import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../../component/message/Msg";
import TableViewer from "../../../component/tableViewer/TableViewer";

const ViewRefferal = () => {
  const [loading, setLoading] = useState(false);
  const token = config.token;
  const navigate = useNavigate();

  const [refferals, setRefferals] = useState([]);

  //  ------For TableViewer ------
  const refferalsRef = useRef([]);
  refferalsRef.current = refferals;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}sales-coupon`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setRefferals(data.data);

        //  ------For TableViewer ------
        const refferalsData = data.data.map((reff) => ({
          token_coupon: reff.coupon,
          course: reff.course_name,
          email: reff.email,
          discount: reff.discount,
          idNumber: reff.scid,
        }));
        setRowData(refferalsData);
        //  ------For TableViewer ------

        setLoading(false);
      });
  }, [token]);

  // ------------------------------------------------------------------ Delete referral -----------------------------------------------------D
  const handleDeleteBtn = (id, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete referral. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id, i);
      }
    });
    //Confirm delete
    const handleDelete = (id, i) => {
      fetch(`${config.host_url}sales-coupon/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Referral deleted successfully");

            //  ------For TableViewer ------
            const updatedRefferals = [...refferalsRef.current];
            updatedRefferals.splice(i, 1);
            setRefferals(updatedRefferals);

            const refferalsData = updatedRefferals.map((reff) => ({
              token_coupon: reff.coupon,
              course: reff.course_name,
              email: reff.email,
              discount: reff.discount,
              idNumber: reff.scid,
            }));
            setRowData(refferalsData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            triggerNotification("error", "Referral not found");
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated User");
          } else {
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        })
        .catch(function (error) {
          console.error("Error:", error);
          triggerNotification("error", "Error deleting referral");
        });
    };
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { field: "token_coupon", filter: true },
    { width: 350, field: "course", filter: true },
    { field: "email", filter: true },
    { field: "discount", filter: true },
  ];
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Token Coupon" subpath={["View Token Coupons"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Token Coupons</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addrefferal");
                }}
              >
                Add Refferal Coupon
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onDelete={handleDeleteBtn}
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewRefferal;
